import { useSelector } from "react-redux";
import DataTableBase from "./DataTableBase";
import { useTranslation } from "react-i18next";
import React from "react";
import { useNavigate } from "react-router-dom";
import { store } from "../../store";
import { Box, Typography } from "@mui/material";
import { Business, Person, Store } from "@mui/icons-material";

export default function BrandsTable() {
  const brands = useSelector((state) => state.brands);
  const users = useSelector((state) => state.users);
  const establishments = useSelector((state) => state.establishments);
  const [selectedBrands, setSelectedbrands] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);

  const userDB = useSelector((state) => state.userDB);

  const navigate = useNavigate();

  const { t } = useTranslation("common");

  // Compter les établissements par enseigne
  const getEstablishmentCount = (brandId) => {
    return establishments?.filter(est => est.brand_id === brandId).length || 0;
  };

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: false,
        filter: false,
        sort: true,
      },
    },
    {
      name: "name",
      label: t("common.name"),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Business sx={{ color: "#78a882", fontSize: 20 }} />
              <Typography sx={{ color: "#ffffff", fontWeight: 500 }}>
                {value}
              </Typography>
            </Box>
          );
        },
      },
    },
    {
      name: "id",
      label: t("common.establishments"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          const count = getEstablishmentCount(value);
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Store sx={{ color: "#6b9dad", fontSize: 20 }} />
              <Typography sx={{ color: "#ffffff", fontWeight: 500 }}>
                {count}
              </Typography>
            </Box>
          );
        },
      },
    },
    {
      name: "owner_id",
      label: t("common.owner"),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const user = users.find((user) => user.id === value);
          return user ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Person sx={{ color: "#c4a574", fontSize: 20 }} />
              <Typography sx={{ color: "#ffffff", fontWeight: 500 }}>
                {user.email}
              </Typography>
            </Box>
          ) : (
            "-"
          );
        },
      },
    },
  ];

  const tableActions = [
    {
      name: t("common.delete_selected", {
        name: t("common.brands"),
        count: selectedBrands.length,
      }),
      icon: "Delete",
      action: () => {
        store.dispatch({
          type: "deleteDialog/update",
          payload: {
            open: true,
            type: "brands",
            records: selectedBrands,
          },
        });
      },
    },
  ];

  if (!brands) {
    return <div>Loading...</div>;
  }

  return (
    <DataTableBase
      columns={columns}
      data={brands}
      title={t("common.brands")}
      id="brand-list"
      name="brand-list"
      pageSize={10}
      selectedItems={selectedBrands}
      setSelectedItems={setSelectedbrands}
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      selectableRows={userDB && userDB.admin ? "multiple" : "none"}
      actions={tableActions}
      sortOrder="dev_eui"
      onRowClick={(rowData, rowMeta) => {
        navigate(`/brands/${brands[rowMeta.dataIndex].id}`);
      }}
    />
  );
}
